'use client';

import { c as _c } from "react/compiler-runtime";
import './home-dashboard.scss';
import { getFeatureFlags } from '@sola/config/lib/getters.ts';
import { ContentFeed } from '../content-feed/content-feed.tsx';
export const HomeDashboard = () => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = getFeatureFlags();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    enableMyContentFeed
  } = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="HomeDashboard__content flex flex-col gap-comfy-sm"><section className="HomeDashboard__primary flex flex-col gap-comfy-sm"><h2 className="text-heading-sm font-bold">Just for You</h2><p className="text-body-sm text-neutral-600">Meaningful ways to stay connected.</p></section>{enableMyContentFeed && <section className="HomeDashboard__primary py-comfy-lg"><ContentFeed /></section>}</div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="HomeDashboard">{t1}<aside className="HomeDashboard__sidebar"><h1>Upcoming Events</h1></aside></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};